import React from 'react';
import { ScrollReveal } from './ui/ScrollReveal';
import { ReceiptIcon, TrendingUpIcon } from 'lucide-react';
export function PainSection() {
  return <section className="py-20 bg-white relative" data-id="element-158">
      <div className="max-w-3xl mx-auto px-4" data-id="element-159">
        <ScrollReveal data-id="element-160">
          <div className="flex justify-center mb-6" data-id="element-161">
            <div className="bg-red-50 p-4 rounded-full" data-id="element-162">
              <ReceiptIcon className="w-10 h-10 text-red-600" data-id="element-163" />
            </div>
          </div>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-center text-brown mb-10 leading-tight" data-id="element-164">
            ¿Sentís que te asaltan cada vez que pasás por la caja de una
            farmacia?
          </h2>
        </ScrollReveal>

        <div className="space-y-6 font-sans text-lg text-brown/80 leading-relaxed" data-id="element-165">
          <ScrollReveal delay={100} data-id="element-166">
            <p data-id="element-167">
              En Argentina, los medicamentos suben más rápido que el dólar. Pero
              lo peor no es el precio... es que nos hicieron olvidar que la
              verdadera medicina no viene en una caja de cartón con prospectos
              ilegibles.
            </p>
          </ScrollReveal>

          <ScrollReveal delay={200} data-id="element-168">
            <div className="bg-parchment/50 border-l-4 border-amber p-6 rounded-r-lg my-8 relative overflow-hidden" data-id="element-169">
              <TrendingUpIcon className="absolute right-[-20px] bottom-[-20px] w-32 h-32 text-amber/10" data-id="element-170" />
              <p className="relative z-10" data-id="element-171">
                ¿Sabías que una gripe familiar hoy puede costar más de{' '}
                <strong className="text-red-700 font-bold text-xl" data-id="element-172">
                  $60.000 ARS
                </strong>{' '}
                entre consultas y fármacos que solo tapan el síntoma?
              </p>
            </div>
          </ScrollReveal>

          <ScrollReveal delay={300} data-id="element-173">
            <p data-id="element-174">
              Estás delegando el bienestar de tus hijos a laboratorios que solo
              ven números.{' '}
              <strong className="text-forest font-bold text-xl block mt-4 text-center" data-id="element-175">
                Es hora de recuperar el control.
              </strong>
            </p>
          </ScrollReveal>
        </div>
      </div>
    </section>;
}